import {ChangeDetectionStrategy, Component, EventEmitter, Output, TemplateRef, ViewChild} from "@angular/core";

@Component({
    selector: 'asi-printer',
    templateUrl: 'printer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AsiPrinter {

    @Output() onReadyToPrint = new EventEmitter<Date>();
    @ViewChild(TemplateRef) template: TemplateRef<any>;

    constructor() {
    }

    ngAfterViewInit() {
        this.onReadyToPrint.emit();
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/printer/printer.component.ts